import Loading from '../../../Common/Loading';
import { WaterAndSewage } from './WaterAndSewage';
import { FamilyExpenses } from './FamilyExpenses';
import { Medications } from './Medications';
import { Rent } from './Rent';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';
import { Alimentation } from './Alimentation';
import { EletricEnergy } from './EletricEnergy';
import { Transportation } from './Transportation';
import { Gas } from './Gas';

export const Charts = () => {
    const { isLoading } = useHouseholdExpensesChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <FamilyExpenses />
                <Rent />
            </div>
            <div className="charts-side-by-side-dashboards">
                <WaterAndSewage />
                <Alimentation />
                <Medications />
            </div>
            <div className="charts-side-by-side-dashboards">
                <EletricEnergy />
                <Transportation />
                <Gas />
            </div>
        </>
    );
};
